import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { LoadingPanel } from "../LoadingPanel";
import { addNotificationWithTimeout } from '../../app/addNotificationWithTimeout';
import { handleResponse } from '../../app/handleResponse';
import { getCSRFToken } from '../../app/getCSRFToken';
import { Switch } from "@progress/kendo-react-inputs";

export const AdministratorRegions = () => {
    const dispatch = useDispatch();

    const [regions, setRegions] = useState([]);
    const [areRegionsLoading, setAreRegionsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const getRegions = () => {
        setAreRegionsLoading(true);

        fetch(`/api/general/regions`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                setAreRegionsLoading(false);
                setRegions(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreRegionsLoading(false);
                setLoadingError(error.message);
            });
    }

    const updateRegion = (regionIsoCode, twoLetterIsoCountryCode, doesNotAllowShorting) => {
        const dataItem = {
            regionIsoCode: regionIsoCode,
            twoLetterIsoCountryCode: twoLetterIsoCountryCode,
            doesNotAllowShorting: doesNotAllowShorting,
        };

        fetch(`/api/administrator/region`,
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Updated shorting not allowed status");

                getRegions();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    };

    const UpdateAllowsShortingStatusCell = (props) => {
        const regionIsoCode = props.dataItem.regionIsoCode;
        const twoLetterIsoCountryCode = props.dataItem.twoLetterIsoCountryCode;
        const doesNotAllowShorting = props.dataItem.doesNotAllowShorting;

        return (
            <td>
                <Switch
                    type={"button"}
                    onChange={() => { updateRegion(regionIsoCode, twoLetterIsoCountryCode, !doesNotAllowShorting) } }
                    checked={doesNotAllowShorting} />
            </td>
        );
    };

    useEffect(() => {
        document.title = "Regions";

        getRegions();
    }, []);

    return (
        <>
            {areRegionsLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <Grid
                    data={regions}
                    resizable={true}
                    scrollable="none"
                >
                    <Column field="name" title={"Region"} />
                    <Column field="countryName" title={"Country"} />
                    <Column title={"Shorting Not Allowed"} cell={UpdateAllowsShortingStatusCell} />
                </Grid>
            ) : <></>)
            }
        </>
    );
}